import snakecaseKeys from 'snakecase-keys';
import {
  GET_USER_PROFILE_MESSAGE_TYPE,
  setUserProfile,
  UserProfile,
} from '@leagueplatform/user-profile-api';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useGetUserProfile } from '@telus-alberta-health-web/shared-module';

export const usePersonalInformation = () => {
  const { data, isLoading, error } = useGetUserProfile();

  const firstName = data?.userProfile?.firstName || '';
  const lastName = data?.userProfile?.lastName || '';

  const preferredFirstName = data?.userProfile?.preferredFirstName;

  // If preferredFirstName is not set, we use the firstName and lastName which is different from the dropdown requirement
  const displayName = preferredFirstName
    ? `${preferredFirstName}`
    : `${firstName} ${lastName}`;

  return {
    data: { ...data, firstName, lastName, displayName, preferredFirstName },
    isLoading,
    error,
  };
};

/**
 * @name useUpdateUserProfile
 * @desc React hook to update the user profile
 * @returns Function that updates user profile
 */
export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();
  const updateUserProfileMutation = useMutation({
    mutationFn: (userProfile: Partial<UserProfile>) =>
      setUserProfile(userProfile),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_USER_PROFILE_MESSAGE_TYPE],
      }),
  });

  return async (userProfile: any) => {
    const serializedBody = snakecaseKeys(userProfile);
    await updateUserProfileMutation.mutateAsync(serializedBody);
  };
};
